export const CONFIDENTIAL_CODE_STORAGE_KEY = 'u12::confidential-code';
